type OptimizeOptions = {
  width?: number;
  height?: number;
};

export default function (url: string, options?: OptimizeOptions): string {
  let result;
  if (
    !url ||
    url.includes("/m/") ||
    !(url.includes(".png") || url.includes(".jpg") || url.includes(".jpeg"))
  ) {
    result = url;
  } else {
    // `/m/` in an image URL tells Storyblok to serve as webp when possible
    result = url.split("/").concat(["m/"]).join("/");
  }

  if (options) {
    const { width, height } = options;
    if (width) {
      if (height) {
        result += `${width}x${height}`;
      } else {
        result += `${width}x0`;
      }
    } else {
      result += `0x${height}`;
    }
  }

  return result;
}

// per the documentation at https://www.storyblok.com/faq/image-dimensions-assets-js
function getIntrinsicSize(url: string): string[] {
  return url.split("/")[5].split("x");
}

export const aspectRatio = (url: string): string =>
  `aspect-ratio: auto ${getIntrinsicSize(url).join(" / ")}`;

export const intrinsicSize = (url: string): { x: number; y: number } => {
  const [x, y] = getIntrinsicSize(url);
  return {
    x: parseInt(x, 10),
    y: parseInt(y, 10),
  };
};
